// components/Accountability/AccountabilityContainer.jsx
import React, { useEffect, useState, useCallback } from "react";
import { progressService } from "../../../../services/progressService";
import { accountabilityRegistry } from "./index";
import { useModal } from "../../ModalContext";

const AccountabilityContainer = ({
  userId,
  course,
  module,
  subsection,
  onProgressUpdate,
  onComplete,
  actions,
  onToggleImmersive,
}) => {
  const [payload, setPayload] = useState({});
  const { openModal, closeModal } = useModal();

  /* ---------- Load user progress ---------- */
  useEffect(() => {
    if (!subsection?.id) return;

    const fetchProgress = async () => {
      try {
        const progress = await progressService.getUserProgress(userId, subsection.id);
        const data = progress?.data?.payload || progress?.payload || {};
        setPayload(data);

        await progressService.updateUserState(userId, subsection.id);
      } catch (err) {
        console.error("Accountability progress load failed:", err);
      }
    };

    fetchProgress();
  }, [userId, subsection?.id]);

  /* ---------- Exit immersive mode ---------- */
  useEffect(() => {
    onToggleImmersive?.(false);
  }, [onToggleImmersive]);

  /* ---------- Save progress ---------- */
  const saveProgress = useCallback(
    async (status, newPayload = {}) => {
      try {
        const updated = await progressService.saveProgress(
          userId,
          subsection.id,
          { type: "accountability", payload: newPayload },
          status
        );
        onProgressUpdate?.(updated);
      } catch (err) {
        console.error("Accountability progress save failed:", err);
        throw err;
      }
    },
    [userId, subsection?.id, onProgressUpdate]
  );

  /* ---------- Select the appropriate screen ---------- */
  const AccountabilityScreen =
    accountabilityRegistry[subsection.subsection_url] || null;

  if (!AccountabilityScreen) {
    return (
      <p className="text-[#6B7280] italic">
        No matching accountability screen found.
      </p>
    );
  }

  /* ---------- Render the specific accountability screen ---------- */
  return (
    <div className="w-full flex-1 min-h-0 overflow-y-auto">
      <h2 className="text-[28px] font-bold text-ink mb-8">{subsection.title}</h2>

      <div className="relative w-full rounded-xl overflow-hidden bg-white shadow-sm p-8">
        <AccountabilityScreen
          subsection={subsection}
          userId={userId}
          payload={payload}
          saveProgress={saveProgress}
          onComplete={onComplete}
          openModal={openModal}
          closeModal={closeModal}
          actions={actions}
        />
      </div>
    </div>
  );
};

export default AccountabilityContainer;
